import moment from 'moment';
import {
    SHIFTS_TAB_UPDATE_DATA,
    SHIFTS_TAB_ENABLE_LOADING,
    SHIFTS_TAB_DISABLE_LOADING,
    SHIFTS_TAB_SET_FILTER_TYPE,
    SHIFTS_TAB_SET_DATE,
    SHIFTS_TAB_SET_PAGINATION,
    SHIFTS_TAB_RESET_PAGINATION,
} from '../actions/constants';

const defaultState = {
    loading: false,
    shiftsData: [],
    filterType: 'day',
    currentSelectedDate: moment().format('YYYY-MM-DD'),
    pagination: {
        pageNumber: 1,
        resultsPerPage: 50,
        isNextPresent: false,
        lastRowIdNext: null,
        lastRowIdPrev: null,
        direction: 'next',
    },
};

export default function (state: any = defaultState, action) {
    switch (action.type) {
        case SHIFTS_TAB_UPDATE_DATA:
            return {
                ...(state || {}),
                shiftsData: action?.data,
                pagination: {
                    ...(state?.pagination || {}),
                    ...(action?.pagination || {}),
                },
            };
        case SHIFTS_TAB_ENABLE_LOADING:
            return { ...(state || {}), loading: true };
        case SHIFTS_TAB_DISABLE_LOADING:
            return { ...(state || {}), loading: false };
        case SHIFTS_TAB_SET_FILTER_TYPE:
            return { ...(state || {}), filterType: action?.data };
        case SHIFTS_TAB_SET_DATE:
            return { ...(state || {}), currentSelectedDate: action.data };
        case SHIFTS_TAB_SET_PAGINATION:
            return { ...(state || {}), pagination: { ...(state || {})?.pagination, ...action?.data } };
        case SHIFTS_TAB_RESET_PAGINATION:
            return { ...(state || {}), pagination: defaultState?.pagination };
        default:
            return state;
    }
}